import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { MerchantData } from './insertMerchant'

const getMerchantRequestBody = (merchantData: MerchantData) => {
  return {
    data: {
      merchantId: merchantData.mid,
      type: 'STATIC',
      qrInterfaceType: 'UPI',
      medium: 'PRINT',
      gstIn: '27AAAAA0000A1Z5',
      intentId: merchantData.intentId,
      notification:
        merchantData.mid === 'NP'
          ? undefined
          : {
              sms: [`+91${merchantData.mobile}`],
            },
      paymentAcceptance: merchantData.mid === 'NP' ? undefined : ['526'],
      vpa: merchantData.vpa ? merchantData.vpa : undefined,
    },
    config: {
      outputType: 'URI',
    },
  }
}

const responseParser = (data: any) => {
  if (data?.data?.status === 'SUCCESS') {
    return data.data.qr
  } else {
    throw data
  }
}

const generateQr = (merchantData: MerchantData, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.generateQr),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: getMerchantRequestBody(merchantData),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { generateQr }
